import React from "react";
import Option from "../Option.jsx";

const UNDEFINED_VALUE = '#UNDEF_VALUE';

export const OptionSetCellRenderer = ({ value, colDef }) => {
  if (value === UNDEFINED_VALUE) return '(Blanks)';

  const original = colDef?.cellRendererParams?.original || {};
  const isHierarchy = original.use_option_set_hierarchy;
  const scope = colDef?.cellRendererParams?.original?.option_set_key;
  const optionMap = colDef?.cellRendererParams?.optionMap;

  const renderValue = (val, index) => {
    const mapped = optionMap?.get(val);

    if (mapped != null) {
      return (
        <React.Fragment key={`${val}-${index}`}>
          {index > 0 ? ', ' : null}
          {mapped}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment key={`${val}-${index}`}>
        {index > 0 ? ', ' : null}
        <Option scope={scope} loadWholeScope={false}>
          {val}
        </Option>
      </React.Fragment>
    );
  };

  if (Array.isArray(value)) {
    return <>{value.map(renderValue)}</>;
  }

  return renderValue(value, 0);
};

// Render array as text, format to option labels
export const optionSetValueFormatter = ({value, colDef: { cellRendererParams }}) => {
  if (value === UNDEFINED_VALUE) return '(Blanks)';

  const optionMap = cellRendererParams?.optionMap;

  const format = (val) => {
    return optionMap?.get(val);
  };

  if (Array.isArray(value)) {
    return value.map(format).join(', ');
  }

  return format(value);
}

export const validateOptionSet = params => {
  const getOptions = params.colDef?.cellRendererParams?.getOptions;
  const options = getOptions ? getOptions(params) : [];
  const values = options.map(o => o.value);

  return !params.value || values.includes(params.value);
};

export const optionSetValueGetter = (params) => {
  const data = (params.data || {})[params.colDef.field];
  return data?.value ?? data;
}

export const getFilteredOptionSetOptions = params => {
  const { colDef, data = {} } = (params ?? {});
  const original = colDef?.cellRendererParams?.original || {};
  const allOptions = original.selection_options || [];

  if (!original.use_option_set_hierarchy) return allOptions;

  const hierarchyLevel = Number(original.option_set_hierarchy_level);

  if (!hierarchyLevel) {
    console.warn('Missing option set hierarchy level', original.accessor, original.name);
    return [];
  }

  const level = hierarchyLevel - 1;
  const dependency = original.dependency_settings?.accessor;
  const index = colDef?.cellRendererParams?.hierarchyOptionsIndex;

  const options = index?.get(`level|${level}`) || [];

  if (!dependency) return options;

  const dependentValue = data[dependency];
  const parentOption = index?.get(`option|${level - 1}|${dependentValue}`);

  if (!parentOption) return [];

  return index?.get(`children|${level}|${parentOption.option_set_key}|${parentOption.value}`) || [];
};